import { formReducer, modelReducer } from 'react-redux-form'
import { combineReducers } from 'redux'

import { handleRest } from '../../js/h2Api'
import { FORM_SUBMIT, PRESELECT_QUOTE_OPTION } from '../actions/actions'

export const initialFormState = {
  email: '',
  firstname: '',
  lastname: '',
  company: '',
  jobtitle: '',
  message: ''
}

export const genericFormState = {}

export const initialQuoteFormState = {
  email: '',
  firstname: '',
  lastname: '',
  company: '',
  address: '',
  city: '',
  state: '',
  phone: '',
  number_of_students: 300,
  student_type: '',
  message: ''
}

const quoteFormPresetOptions = {}
const reducerRequest = (state = handleRest(), action) => {
  switch (action.type) {
    case FORM_SUBMIT:
      return {
        ...handleRest(action)
      }
    default:
      return state
  }
}
const quoteFormPresetReducer = (state = quoteFormPresetOptions, action) => {
  switch (action.type) {
    case PRESELECT_QUOTE_OPTION:
      console.log(action)

      return {
        ...state,
        [action.fieldName]: action.value
      }
    default:
      return state
  }
}
const reducers = combineReducers({
  arkansasForm: modelReducer('forms.arkansasForm', initialFormState),
  genericForm: modelReducer('forms.genericForm', genericFormState),
  forms: formReducer('forms', {
    arkansasForm: initialFormState,
    genericForm: genericFormState
  }),
  formRequest: reducerRequest,
  quoteFormPresetReducer
})

export default reducers
